<template>
  <div class="products-302">

    <m-categories312
        @isSelectionDone="isSelectionDone"
        :singleCategory="singleCategory"
        class="mt-2" @selectedCategories="setProductCategory"/>
    <m-products-wrapper :per-page="perPage" :wait-for-category="true"
                        v-if="showProducts"
                        product-category-column="slug"
                        product-brand-column="slug"
                        :wait-for-brand="waitForBrand()"
                        :product-brands="productBrands"
                        :product-categories="productCategory">
      <template v-slot="{products,pagination,changePageFunction}">
        <div>
          <div class="row" v-if="products.length > 0">
            <template v-for="product in products">
              <component :class="cardClass" :is="productCardName" :product="product"/>
            </template>
            <!--            <m-product-card302 class="col-lg-4 my-2 rounded rounded-9" v-for="product in products" :product="product"/>-->
          </div>
          <h4 v-else class="text-center my-2" v-t="'product.no_item'"></h4>

          <div class="row" v-if="paginate">
            <m-paginate1 class="mx-auto my-3" :on-change-page="changePageFunction" :meta="pagination"/>
          </div>

        </div>
      </template>
    </m-products-wrapper>

  </div>
</template>

<script>
import mProductsWrapper from "../../../Wrappers/ProductWrapper";
import mProductPrice100 from "../../../Product/ProductPrice100";
import mShoppingCartController1 from "../../../Product/ShoppingCartController1";
import mPaginate1 from "../../../Pagination/Paginate1";
import mProductModal302 from "../../Card/ProductCard302/ProductModal302.vue";
import mCategories312 from "../../../Category/Categories/Categories312.vue";
import mProductCardQuantityManager1 from "../../QuantityManager/Card/ProductCardQuantityManager1";
import mProductWrapper from "../../../Wrappers/ProductWrapper.vue";
import {Cards} from "../../Card/Cards";

export default {
  name: "Products302",
  components: {
    mProductWrapper,
    mProductsWrapper,
    mProductCardQuantityManager1,
    mProductPrice100,
    mShoppingCartController1,
    mPaginate1,
    mProductModal302,
    mCategories312,
    ...Cards
  },
  props: {
    paginate: {
      default: false
    },
    perPage: {
      default: 12
    },
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard302'
    },
    singleCategory: {
      default: null
    },
    cardClass:{
      default:'col-lg-4 my-2 rounded rounded-9'
    }
  },
  data() {
    return {
      productBrands: null,
      selectedCategory: [],
      productCategory: null,
      showProducts: false,
    }
  },
  methods: {
    setProductCategory(categories) {
      let result = []

      for (let index in categories) {
        result.push(categories[index].slug)
      }
      this.productCategory = result
      this.showProducts = true
    },
    waitForBrand() {
      return this.productBrands != null && this.productBrands.length > 0;
    },
    setProductBrandFromQuery() {
      let brand = this.$route.query.brand;
      let brandColumn = this.$route.query.brand_column

      if (brand !== undefined) {
        this.productBrands = []
        brand.split(',').forEach(item => {
          this.productBrands.push(item)
        })
      }
      if (brandColumn !== undefined) {
        this.productBrandColumn = brandColumn
      }
      return true
    },
    isSelectionDone(data) {
      this.showProducts = data
    }
  },
  mounted() {
    this.$store.commit('Product/setFilters', {key: 'quantity', value: ''})
    this.setProductBrandFromQuery()
  }
}
</script>


<style scoped>


</style>